export default "__VITE_ASSET__D935Vrjo__"